import React from 'react';
import { CustomSelect } from '../custom-select';
import * as S from './items-per-page.styles';
const defaultItemsPerPage = [10, 25, 50, 75, 100];
export const ItemsPerPage = ({ onChange, value, isDisabled, title, pageOptions = defaultItemsPerPage, }) => {
    const selectOptions = pageOptions.map((num) => ({
        value: num.toString(),
        label: num.toString(),
    }));
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        React.createElement(CustomSelect, { name: "itemsPerPage", options: selectOptions, value: value, onChange: (event) => onChange(Number(event.target.value)), isDisabled: isDisabled })));
};
//# sourceMappingURL=items-per-page.js.map